import  React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Redirect } from 'react-router-dom';
import { fetchRequest as getMyCourseAction} from '../../store/myCourse/actions'
import { editRequest as updateMyCourseAction} from '../../store/myCourse/actions'
import { selectCourse as selectCourseAction } from '../../store/myCourse/actions'
import { getMySelectedCourse } from '../../store/myCourse/selectors'
import Player from './Player';
import {UserCourseUtil} from '../../utils/dataUtil'
import { Button, ButtonGroup, Spinner, Row, Col, Form, FormGroup, Label, Input }  from 'reactstrap';

import { IUser, IUserCourse } from '../../store/interface'

// @ts-ignore
import StarRatings from 'react-star-ratings';
// @ts-ignore
import Select from 'react-select';

import {
    Collapse,
    Container,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
  import '@fortawesome/fontawesome-free/css/all.css';
  import { Link } from 'react-router-dom';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    selected?: IUserCourse
    route:any
    user:IUser
    data: any   
}

interface IPopupImage{
    image?:string[]
    show:boolean
}
interface IState {
    [key: string]: any
    id:string
    fireRedirect:any
    start:boolean
    playing:boolean
    startFrom:number
    stop:boolean
    popupImage:IPopupImage
    isOpen:boolean
    selectedImageUrl:string
    showConcentrationAnswer:string
    FeedbackSubmitted:boolean
    qRating:number
    qEffective:number
    qTrainer:number
    qDifficulty:number
    qExpectation:number
    qUsePlatform:number
    qImprovement:string
    qComment:string
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    selectCourse: typeof selectCourseAction
    fetchRequest : typeof getMyCourseAction
    editRequest: typeof updateMyCourseAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class Feedback extends React.Component<AllProps,IState> {
    
    userCourseData = new UserCourseUtil();
    constructor(props:AllProps){
        super(props)
        //this.handleEdit = this.handleEdit.bind(this)
        this.state = {
            id : this.props.route.match.params.id,
            fireRedirect: false,
            start:false,
            playing:false,
            startFrom:0,
            stop:false,
            popupImage:{ show:false},
            isOpen:false,
            selectedImageUrl:"",
            showConcentrationAnswer:"",
            FeedbackSubmitted: this.props.data?.feedbackSubmitted,
            qRating: this.props.data?.feedback?.rating,
            qEffective: this.props.data?.feedback?.effectiveRating,
            qTrainer: this.props.data?.feedback?.trainerRating,
            qDifficulty: this.props.data?.feedback?.difficultyRating,
            qExpectation : this.props.data?.feedback?.expectation,
            qUsePlatform: this.props.data?.feedback?.usePlatform,
            qImprovement : this.props.data?.feedback?.improvement,
            qComment : this.props.data?.feedback?.comment
        }

        const id = this.props.route.match.params.id;
        this.props.selectCourse(id);
        this.changeRating = this.changeRating.bind(this);
        this.SubmitFeedback = this.SubmitFeedback.bind(this);
        this.handleExpectation = this.handleExpectation.bind(this);
        this.handleUsePlatform = this.handleUsePlatform.bind(this);
    }

    toggle() {
        this.setState({
        isOpen: !this.state.isOpen
        });
    }
    
    public componentDidMount() {
        //const { fetchRequest: fr } = this.props
        //fr()
        // const courseId = this.props.route.match.params.id;
        // this.userCourseData.Get(courseId).then(this.GetUserCourseData.bind(this)).catch(console.log);

        const { fetchRequest: fr, data } = this.props;

        var searchParams:any = {};
        searchParams["id"] = this.props.route.match.params.id;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        if (data == undefined){
            fr(searchParams);
        }
    }
    
    componentWillUnmount(){

    }

    componentDidUpdate(prevProps:AllProps) {
        if (prevProps.data?.feedback != this.props.data?.feedback){
            this.setState({
                FeedbackSubmitted : this.props.data?.feedbackSubmitted,
                qRating: this.props.data?.feedback?.rating,
                qEffective: this.props.data?.feedback?.effectiveRating,
                qTrainer: this.props.data?.feedback?.trainerRating,
                qDifficulty: this.props.data?.feedback?.difficultyRating,
                qExpectation : this.props.data?.feedback?.expectation,
                qUsePlatform: this.props.data?.feedback?.usePlatform,
                qImprovement : this.props.data?.feedback?.improvement,
                qComment : this.props.data?.feedback?.comment
              });
        }
    }
    GetUserCourseData(data:any){
        this.setState({startFrom:data.currentTime});
    }
    changeRating(newRating:number, name:any) {
        this.setState({
            [name]: newRating
        });
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
        
        console.log(value);
    }
    handleExpectation(val:number){
        this.setState({qExpectation : val });
    }
    handleUsePlatform(val:number){
        this.setState({qUsePlatform : val });
    }

    SubmitFeedback(){

        if (this.state.qRating === undefined || this.state.qRating === 0 ||
            this.state.qEffective === undefined || this.state.qEffective === 0 || 
            this.state.qTrainer === undefined || this.state.qTrainer === 0 || 
            this.state.qDifficulty === undefined || this.state.qDifficulty === 0 || 
            this.state.qExpectation === undefined || this.state.qExpectation === 0 || 
            this.state.qUsePlatform === undefined || this.state.qUsePlatform === 0){

            alert('Please fill in feedback form before proceed.');
            return;
        }

        let kv:any = {};
        kv.id = this.state.id;
        //kv.createIfNotExists = true;
        kv.feedbackSubmitted = true;
        kv.certIsGenerated = false;
        kv.feedback = { 
            rating: this.state.qRating,
            effectiveRating: this.state.qEffective,
            trainerRating: this.state.qTrainer,
            difficultyRating: this.state.qDifficulty,
            expectation : this.state.qExpectation, 
            usePlatform : this.state.qUsePlatform, 
            improvement : this.state.qImprovement, 
            comment : this.state.qComment, 
            submittedOn : new Date(),
            submittedBy : this.props.user.emailAdd
        };
        
        const { editRequest: er } = this.props;
        er(kv);
    }

    public render() {
        return <Fragment> 
            { this.RenderLayout() }
            {
                this.props.data?.feedbackSubmitted? this.renderSubmitted() : this.renderFeedbackForm() 
            }
        </Fragment>;
    }
    public renderSubmitted(){
        return <Fragment>
        <Row>
            <Col lg="3"></Col>
            <Col lg="6"><hr/></Col>
            <Col lg="3"></Col>
        </Row>
        <Row>
            <Col lg="4"></Col>
            <Col lg="4" style={{textAlign:"center"}}><h1>Thank You for your valuable feedback</h1></Col>
            <Col lg="4"></Col>
        </Row>
        <Row>
            <Col lg="3"></Col>
            <Col lg="6"><hr/></Col>
            <Col lg="3"></Col>
        </Row>
        <Row>
            <Col lg="4"></Col>
            <Col lg="4" style={{textAlign:"center"}}><Link className="btn btn-primary" to='/mycourses'>Back to my course list</Link></Col>
            <Col lg="4"></Col>
        </Row>
        </Fragment>
    }
    public renderFeedbackForm() {
        return <Fragment>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6"><hr/></Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="4"></Col>
                <Col lg="4" style={{textAlign:"center"}}><h1>Feedback</h1></Col>
                <Col lg="4"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6"><hr/></Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                    <span className="feedbackQuestion">1. How would you rate for this online training? </span><br/>
                    </div>
                    <span className="feedbackAnswerLabel" style={{paddingLeft:"25px"}}>Poor&nbsp;&nbsp;&nbsp;</span>
                    <StarRatings
                        rating={this.state.qRating} starRatedColor="#ECBE22" numberOfStars={5}
                        changeRating={this.changeRating} name='qRating' starDimension = "35px" />
                    <span className="feedbackAnswerLabel">&nbsp;&nbsp;&nbsp;Excellent</span>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">2. Did you find the seminar effective? </span><br/>
                    </div>
                    <span className="feedbackAnswerLabel" style={{paddingLeft:"25px"}}>Not effective&nbsp;&nbsp;&nbsp;</span>
                    <StarRatings
                        rating={this.state.qEffective} starRatedColor="#ECBE22" numberOfStars={5}
                        changeRating={this.changeRating} name='qEffective' starDimension = "35px" />
                    <span className="feedbackAnswerLabel">&nbsp;&nbsp;&nbsp;Very effective</span>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">3. How well did the trainer state the objectives?  </span><br/>
                    </div>
                    <span className="feedbackAnswerLabel" style={{paddingLeft:"25px"}}>Poor&nbsp;&nbsp;&nbsp;</span>
                    <StarRatings
                        rating={this.state.qTrainer} starRatedColor="#ECBE22" numberOfStars={5}
                        changeRating={this.changeRating} name='qTrainer' starDimension = "35px" />
                    <span className="feedbackAnswerLabel">&nbsp;&nbsp;&nbsp;Excellent</span>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">4. Did the content easy to understand? </span><br/>
                    </div>
                    <span className="feedbackAnswerLabel" style={{paddingLeft:"25px"}}>Hard&nbsp;&nbsp;&nbsp;</span>
                    <StarRatings
                        rating={this.state.qDifficulty} starRatedColor="#ECBE22" numberOfStars={5}
                        changeRating={this.changeRating} name='qDifficulty' starDimension = "35px" />
                    <span className="feedbackAnswerLabel">&nbsp;&nbsp;&nbsp;Easy</span>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>            
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">5. Did it cover your expectation?</span><br/>
                    </div>
                    <ButtonGroup style={{paddingLeft:"25px"}} id="1">
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#67C64A"}} onClick={() => this.handleExpectation(1)} active={this.state.qExpectation === 1}>Yes</Button>&nbsp;
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#EF3749"}} onClick={() => this.handleExpectation(2)} active={this.state.qExpectation === 2}>No</Button>&nbsp;
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#EDD125"}} onClick={() => this.handleExpectation(3)} active={this.state.qExpectation === 3}>Moderate</Button>
                    </ButtonGroup>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">6. Will you continue to use this platform for other seminars?  </span><br/>
                    </div>
                    <ButtonGroup style={{paddingLeft:"25px"}} id="2">
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#67C64A"}} onClick={() => this.handleUsePlatform(1)} active={this.state.qUsePlatform === 1}>Yes</Button>&nbsp;
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#EF3749"}} onClick={() => this.handleUsePlatform(2)} active={this.state.qUsePlatform === 2}>No</Button>&nbsp;
                        <Button className="feedback" style={{width:"100px", backgroundColor:"#EDD125"}} onClick={() => this.handleUsePlatform(3)} active={this.state.qUsePlatform === 3}>Sometimes</Button>
                    </ButtonGroup>
                    <br/><br/>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">7. Is any feedback to keep us improvement to serve you better? </span><br/>
                    </div>
                   <Form style={{paddingLeft:"25px"}}>
                        <FormGroup row={true}>
                            <Col sm={12}>
                                <div className="form-group">
                                    <Input type="textarea" name="qImprovement" id="qImprovement"
                                        value={this.state.qImprovement} rows = {5}
                                        onChange={this.handleChange.bind(this)} />
                                </div>
                            </Col>
                        </FormGroup>
                   </Form>
                </Col>
                <Col lg="3"></Col>
            </Row>
            
            <Row>
                <Col lg="3"></Col>
                <Col lg="6" style={{textAlign:"left"}}>
                    <div className="feedbackQuestionContainer">
                        <span className="feedbackQuestion">8. Any others comment for this seminar? </span><br/>
                    </div>
                   <Form style={{paddingLeft:"25px"}}>
                        <FormGroup row={true}>
                            <Col sm={12}>
                                <div className="form-group">
                                    <Input type="textarea" name="qComment" id="qComment"
                                        value={this.state.qComment} rows = {5}
                                        onChange={this.handleChange.bind(this)} />
                                </div>
                            </Col>
                        </FormGroup>
                   </Form>
                </Col>
                <Col lg="3"></Col>
            </Row>
            <Row>
                <Col lg="3"></Col>
                <Col lg="6">
                    <Button color="primary" className=" float-right" onClick={this.SubmitFeedback}>Send</Button>
                </Col>
                <Col lg="3"></Col>
            </Row>

        </Fragment>
    }
    
    public RenderLayout(){
        return (
            <div>
              <Navbar color="" dark expand="md" fixed="top" style={{backgroundColor:"#3A3A3C"}}>
                <Container fluid={true}>
                  <NavbarBrand href="/">
                  <img src="/images/logo.png" height="40px" alt="Logo"/>
                    </NavbarBrand>
                  <Nav className="mr-auto" navbar>
                      <NavItem>
                        <span style={{color: "#fff"}}>
                            {this.props.data?.courseTitle}
                        </span>
                     </NavItem>
                    </Nav>
                  <NavbarToggler onClick={this.toggle.bind(this)} />
                  <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav className="mr-auto" navbar>
                      
                    </Nav>
                    <Nav className="justify-content-end" navbar>
                    <NavItem>
                        <span style={{color: "#fff"}}>Tips</span>
                      </NavItem>
                    </Nav>
                  </Collapse>
                </Container>
              </Navbar>
            </div>
          );
           
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState, ownProps:any) => ({
    //data:company.data,
    //user: state.userReducer
    user: state.userInfo.byId[0],
    selected: getMySelectedCourse(state, ownProps.route.match.params.id),
    data: getMySelectedCourse(state, ownProps.route.match.params.id),
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    selectCourse:selectCourseAction,
    fetchRequest: getMyCourseAction,
    editRequest: updateMyCourseAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Feedback)
